import React from "react";
import ro from "/src/content/ro.json";

const TermeniConditii = () => {
  const content = ro.legal.terms;

  return (
    <div
      className="max-w-4xl mx-auto px-6 py-12"
      style={{ color: "var(--color-text)", backgroundColor: "var(--color-bg)" }}
    >
      <h1 className="text-3xl font-bold text-orange-500 mb-6">
        {content.title}
      </h1>

      <p>{content.intro}</p>

      {content.sections.map((section) => (
        <React.Fragment key={section.title}>
          <h2 className="text-xl font-semibold mt-6">{section.title}</h2>
          <p>{section.text}</p>
        </React.Fragment>
      ))}
    </div>
  );
};

export default TermeniConditii;
